import { SHA256, enc } from 'crypto-js';

export function hash(message: string) {
    return SHA256(message).toString(enc.Hex)
}